<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      class="drawer"
      dark
      app
      :height="this.$vuetify.breakpoint.height * 0.95"
      hide-overlay
      persistent
      mobilebreak-point="1280"
      v-if="!isGuestUser"
    >
      <v-btn
        title
        width="90%"
        light
        class="pa-5 mt-3 ml-2 font-weight-black"
        link
        :to="{ name: 'assets.index' }"
      >
        <v-icon color="primary" class="mr-3">
          mdi-home
        </v-icon>
        {{ $t("dashboard.assets_list") }}</v-btn
      >
      <v-treeview
        :items="treeElements"
        activatable
        hoverable
        rounded
        dense
        open-on-click
        v-if="getTreeData.length"
      >
        <template v-slot:prepend="{ open }">
          <v-icon color="primary" class="ml-n1">
            {{ open ? "mdi-folder-open" : "mdi-folder" }}
          </v-icon>
        </template>

        <template v-slot:label="{ item }">
          <v-btn
            text
            color="primary"
            link
            title="Équipement"
            class="ml-n3"
            v-if="item.level === 5"
            :to="{ name: 'lots.show', params: { id: item.id } }"
          >
            {{ item.name }}</v-btn
          >
          <v-btn
            text
            link
            title="Catégorie"
            class="ml-n3"
            v-if="item.level === 4"
            :to="{ name: 'assets.show', params: { id: item.id } }"
          >
            {{ item.name }}
          </v-btn>
          <v-btn
            text
            link
            class="ml-n3"
            v-if="item.level === 3"
            :to="{ name: 'assets.index', params: { assetID: item.id } }"
          >
            {{ item.name }}
          </v-btn>
          <v-btn
            text
            link
            class="ml-n3"
            v-if="item.level === 2"
            :to="{ name: 'assets.l2.show', params: { assetID: item.id } }"
          >
            {{ item.name }}
          </v-btn>
        </template>
      </v-treeview>

      <v-skeleton-loader
        ref="skeleton"
        type="list-item-three-line"
        class="mx-auto"
        v-else
      ></v-skeleton-loader>
      <template>
        <v-icon color="green" class="ml-8 mt-6">
          mdi-comment-question-outline
        </v-icon>
        <v-btn @click="support()" class="green mt-6 ml-3 pl-2">
          MON SUPPORT
        </v-btn>
        <v-icon color="green" class="ml-8 mt-3">
          mdi-video
        </v-icon>
        <v-btn @click="tuto()" class="green mt-3 ml-3 pl-2">
          MES TUTOS
        </v-btn>
      </template>
    </v-navigation-drawer>
    <v-snackbar v-model="show" :timeout="10000" dark top>
      <v-icon dark>help</v-icon>
      {{ $t("dashboard.help_text") }}
      <v-btn dark text @click="show = false">
        {{ $t("close") }}
      </v-btn>
    </v-snackbar>
    <v-app-bar
      v-if="isDirectLink && isMobilePaysage"
      app
      collapse
      height="30px"
      color="primary"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />

      <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu offset-y :nudge-width="150">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-avatar class="white" size="22">
              <v-icon color="primary" small>person</v-icon>
            </v-avatar>
          </v-btn>
        </template>

        <v-list class="pa-0" light>
          <v-list-item avatar>
            <v-list-item-avatar>
              <v-avatar class="primary" size="48px">
                <v-icon dark>person</v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{
                getUserData && getUserData.registration_number
                  ? getUserData && getUserData.registration_number.toUpperCase()
                  : getUserData && getUserData.name
              }}</v-list-item-title>
              <v-list-item-title>{{
                getUserProfile && getUserProfile.name.toLowerCase().substring(3)
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>

          <!--<v-list-item key="profile" @click="doSomething()">
            <v-list-item-icon>
              <v-icon>person</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Mon Profil</v-list-item-title>
            </v-list-item-content>
          </v-list-item>-->
          <v-divider></v-divider>

          <v-list-item key="lock_open" @click="onLogout()">
            <v-list-item-icon>
              <v-icon>lock_open</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("dashboard.logout")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu v-if="isMultiLang" v-model="value" close-on-click>
        <template v-slot:activator="{ on }">
          <v-btn class="ml-3" small color="primary" v-on="on">
            <gb-flag :code="selectedLang.icon" size="micro" />
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group v-model="language" color="primary">
            <v-list-item
              v-for="(item, index) in languages"
              :key="index"
              @click="changeLang"
            >
              <v-list-item-icon>
                <gb-flag :code="item.icon" size="micro" />
              </v-list-item-icon>
              <v-list-item-title>{{
                $t(`langs.${item.key}`)
              }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
      <v-btn icon @click="show = true">
        <v-icon>help</v-icon>
      </v-btn>
    </v-app-bar>

    <v-app-bar
      v-else-if="isMobilePaysage"
      app
      collapse-on-scroll
      color="primary"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />

      <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu offset-y :nudge-width="150">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-avatar class="white" size="32">
              <v-icon color="primary">person</v-icon>
            </v-avatar>
          </v-btn>
        </template>

        <v-list class="pa-0" light>
          <v-list-item avatar>
            <v-list-item-avatar>
              <v-avatar class="primary" size="48px">
                <v-icon dark>person</v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{
                getUserData && getUserData.registration_number
                  ? getUserData && getUserData.registration_number.toUpperCase()
                  : getUserData && getUserData.name
              }}</v-list-item-title>
              <v-list-item-title>{{
                getUserProfile && getUserProfile.name.toLowerCase().substring(3)
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>

          <!--<v-list-item key="profile" @click="doSomething()">
            <v-list-item-icon>
              <v-icon>person</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Mon Profil</v-list-item-title>
            </v-list-item-content>
          </v-list-item>-->
          <v-divider></v-divider>

          <v-list-item key="lock_open" @click="onLogout()">
            <v-list-item-icon>
              <v-icon>lock_open</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("dashboard.logout")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu v-if="isMultiLang" v-model="value" close-on-click>
        <template v-slot:activator="{ on }">
          <v-btn class="ml-3" small color="primary" v-on="on">
            <gb-flag :code="selectedLang.icon" size="micro" />
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group v-model="language" color="primary">
            <v-list-item
              v-for="(item, index) in languages"
              :key="index"
              @click="changeLang"
            >
              <v-list-item-icon>
                <gb-flag :code="item.icon" size="micro" />
              </v-list-item-icon>
              <v-list-item-title>{{
                $t(`langs.${item.key}`)
              }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
      <v-btn icon @click="show = true">
        <v-icon>help</v-icon>
      </v-btn>
    </v-app-bar>

    <v-app-bar v-else app color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>{{
        pageTitle ? pageTitle : "Keep in Touch"
      }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-menu offset-y :nudge-width="150">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-avatar class="white" size="32">
              <v-icon color="primary">person</v-icon>
            </v-avatar>
          </v-btn>
        </template>

        <v-list class="pa-0" light>
          <v-list-item avatar>
            <v-list-item-avatar>
              <v-avatar class="primary" size="32px">
                <v-icon dark>person</v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{
                getUserData && getUserData.registration_number
                  ? getUserData && getUserData.registration_number.toUpperCase()
                  : getUserData && getUserData.name
              }}</v-list-item-title>
              <v-list-item-title
                >({{
                  getUserProfile &&
                    getUserProfile.name.toLowerCase().substring(3)
                }})</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>

          <!--<v-list-item key="profile" @click="doSomething()">
            <v-list-item-icon>
              <v-icon>person</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Mon Profil</v-list-item-title>
            </v-list-item-content>
          </v-list-item>-->
          <v-divider></v-divider>

          <v-list-item key="lock_open" @click="onLogout()">
            <v-list-item-icon>
              <v-icon>lock_open</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("dashboard.logout")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu v-if="isMultiLang" v-model="value" close-on-click>
        <template v-slot:activator="{ on }">
          <v-btn class="ml-3" small color="primary" v-on="on">
            <gb-flag :code="selectedLang.icon" size="micro" />
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group v-model="language" color="primary">
            <v-list-item
              v-for="(item, index) in languages"
              :key="index"
              @click="changeLang"
            >
              <v-list-item-icon>
                <gb-flag :code="item.icon" size="micro" />
              </v-list-item-icon>
              <v-list-item-title>{{
                $t(`langs.${item.key}`)
              }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <v-btn icon @click="show = true">
        <v-icon>help</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-slide-y-transition mode="out-in" v-if="loaded">
        <router-view :key="$root.$i18n.locale" />
      </v-slide-y-transition>
    </v-main>
  </v-app>
</template>

<script>
import { LayoutOptions } from "../mixins/layouts";
import { mapActions, mapGetters } from "vuex";
import { TreeViewData } from "../mixins/tree-view";
import USER_API from "../api/user";
import TICKET_API from "../api/ticket";
import { loadStates, shouldDisplay, uniqueElementBy } from "../utils";
import { blobToImage } from "../utils/upload";
import { TicketsData } from "../mixins/tickets-data";
import { AssetsData } from "../mixins/asset";
import { Icon } from "leaflet";
import { langs } from "../utils/lang";
import { PORTAL_CONFIG } from "../config";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

export default {
  props: {
    source: String
  },
  data() {
    return {
      drawer: true,
      show: false,
      parentRoot: true,
      languages: langs,
      language: undefined,
      value: false
    };
  },
  created() {
    if (this.isAuth && !this.sessionIsInit) {
      if (this.getUserApiToken) {
        this.$store.dispatch("initSession", this.getUserApiToken).then(() => {
          this.loadEquipData();
          this.loadData();
        });
      } else {
        this.killSession();
      }
    }
    /*if (
      this.isAuth &&
      !this.$route.meta.directLink &&
      this.$route.name !== "assets.index"
    ) {
      this.$router.push("/assets/index");
    }*/
    if (!this.getSessionToken) {
      this.killSession();
    }
    if (this.sessionIsInit) {
      this.loadEquipData();
      this.loadData();
      if (this.isAuth && this.loaded) {
        //this.listData();
      }
    }
    if (this.pageTitle) {
      document.title = this.pageTitle;
    }
  },
  mounted() {
    this.language = this.selectedLangIndex;
  },
  computed: {
    ...mapGetters([
      "isAuth",
      "sessionIsInit",
      "getSessionToken",
      "getUserApiToken",
      "getCharges",
      "getChargesLoadStatus",
      "getTravaux",
      "getTravauxLoadStatus",
      "getAllTickets",
      "getAllTicketsLoadStatus",
      "getDocuments",
      "getDocumentsLoadStatus",
      "getDocumentsImages",
      "getEquipmentLoadStatus",
      "getEquipments",
      "getReservations",
      "getReservationsLoadStatus",
      "getTicketsTasksLoadStatus",
      "getAllITILSolutions",
      "getAllITILSolutionsLoadStatus",
      "getAllITILFollowups",
      "getAllITILFollowupsLoadStatus",
      "getProjectsLoadStatus",
      "getProjectsTaskLoadStatus",
      "getTypeName",
      "getUserId",
      "getUsersLoadingStatus",
      "getActiveEntity"
    ]),
    loaded() {
      return (
        (this.getChargesLoadStatus === loadStates.SUCCESS &&
          this.getTravauxLoadStatus === loadStates.SUCCESS &&
          this.getAllTicketsLoadStatus === loadStates.SUCCESS &&
          this.getDocumentsLoadStatus === loadStates.SUCCESS) ||
        this.$route.meta.directLink
      );
    },
    treeElements() {
      return this.getTreeData;
    },
    pageTitle() {
      if (this.$route.meta.directIt) {
        return this.getActiveEntity.name;
      } else if (this.$route.name === "assets.index") {
        return this.$t("dashboard.default_page_title");
      } else if (
        this.$vuetify.breakpoint.width < this.$vuetify.breakpoint.thresholds.xs
      ) {
        if (this.selectedEntity && this.selectedEntity.level === 5) {
          let name = this.selectedEntity ? this.selectedEntity.name : "";
          return name ? name : this.selectedEntity.name;
        }
        return this.selectedEntity ? this.selectedEntity.name : "";
      } else {
        if (this.selectedEntity && this.selectedEntity.level === 5) {
          let name = this.selectedEntity
            ? this.selectedEntity.completename.split(">")[3] +
              "> " +
              this.selectedEntity.name
            : "";
          return name ? name : this.selectedEntity.name;
        }
        return this.selectedEntity ? this.selectedEntity.name : "";
      }
    },
    isMultiLang() {
      return this.getUserId === 13 || this.getUserId === 14;
    },
    isMobilePaysage() {
      return (
        this.$vuetify.breakpoint.width <
          this.$vuetify.breakpoint.thresholds.md &&
        this.$vuetify.breakpoint.height < this.$vuetify.breakpoint.width
      );
    },
    isDirectLink() {
      return this.$route.meta.directLink;
    },
    IsSessionLoading() {
      return (
        this.getSessionLoadState === loadStates.PENDING ||
        this.getProfileLoadingStatus === loadStates.PENDING
      );
    },
    selectedLangIndex() {
      return this.languages.indexOf(this.selectedLang);
    },
    selectedLang() {
      return this.languages.find(
        lang => lang.local === this.$root.$i18n.locale
      );
    }
  },
  methods: {
    ...mapActions([
      "login",
      "reloadSession",
      "loadCharges",
      "loadTravaux",
      "loadAllTickets",
      "loadDocuments",
      "killSession",
      "addDocumentsImages",
      "loadEquipment",
      "loadReservations",
      "loadTicketsTasks",
      "loadAllITILSolutions",
      "loadAllITILFollowups",
      "loadProject",
      "loadProjectTasks",
      "loadItemType",
      "loadUsers"
    ]),
    async loadData() {
      if (this.isAuth && this.entitiesLoaded) {
        if (!this.$route.meta.directLink) {
          if (this.getChargesLoadStatus === loadStates.INITIAL_STATE) {
            USER_API.getCharge().then(response => {
              this.loadCharges(response.data);
            });
          }
          if (this.getTravauxLoadStatus === loadStates.INITIAL_STATE) {
            USER_API.getTravaux().then(response => {
              this.loadTravaux(response.data);
            });
          }
          if (this.getDocumentsLoadStatus === loadStates.INITIAL_STATE) {
            USER_API.getPhotos().then(response => {
              const docs = response.data.filter(
                entity => entity.documentcategories_id === 2
              );
              const nb_photo = docs.length;
              if (nb_photo > 10) {
                const quantity = 10;
                const max = nb_photo - 1;
                const arr = [];
                while (arr.length < quantity) {
                  var candidateInt = Math.floor(Math.random() * max) + 1;
                  if (arr.indexOf(candidateInt) === -1) arr.push(candidateInt);
                }
                let docs_lim = [];
                for (let i = 0; i < quantity; i++) {
                  docs_lim.push(docs[arr[i]]);
                  this.loadDocuments(docs[arr[i]]);
                }
                this.loadDocuments(docs_lim);
              } else this.loadDocuments(docs);
            });
          }

          /* calendar plus utilise
          if (this.getReservationsLoadStatus === loadStates.INITIAL_STATE) {
            this.loadCalendar();
          }*/
        }

        if (this.getUsersLoadingStatus === loadStates.INITIAL_STATE) {
          this.loadUsers();
        }

        if (this.getAllTicketsLoadStatus === loadStates.INITIAL_STATE) {
          USER_API.getAllTickets().then(async response => {
            const tickets = await this.loadEquipmentsData(response.data);
            TICKET_API.getTasks().then(({ data }) => {
              let tasks = [];
              tickets.forEach(ticket => {
                const ticketTasks = data
                  .filter(task => task.tickets_id === ticket.id)
                  .map(task => {
                    task.entities_id = ticket.entities_id;
                    return task;
                  });
                if (ticketTasks && ticketTasks.length > 0) {
                  tasks = tasks.concat(ticketTasks);
                }
              });
              this.$store.commit("setTicketsTasks", tasks);
              this.$store.commit(
                "setTicketsTasksLoadStatus",
                loadStates.SUCCESS
              );
            });
          });
        }

        if (this.getAllITILSolutionsLoadStatus === loadStates.INITIAL_STATE) {
          USER_API.getAllITILSolutions().then(response => {
            this.loadAllITILSolutions(response.data);
          });
        }
        if (this.getAllITILFollowupsLoadStatus === loadStates.INITIAL_STATE) {
          USER_API.getAllITILFollowups().then(response => {
            this.loadAllITILFollowups(response.data);
          });
        }
        /*if (this.getTicketsTasksLoadStatus === loadStates.INITIAL_STATE) {
          TICKET_API.getTasks().then(({ data }) => {
            this.loadTicketsTasks(data);
          });
        }*/

        if (this.getProjectsTaskLoadStatus === loadStates.INITIAL_STATE) {
          USER_API.getAllProjectTask().then(({ data }) => {
            this.loadProjectTasks(data);
          });
        }
      }
    },
    loadEquipData() {
      if (
        this.isAuth &&
        !this.isSessionLoading &&
        this.getEquipmentLoadStatus === loadStates.INITIAL_STATE
      ) {
        USER_API.getLocations().then(({ data }) => {
          this.loadEquipment(data);
          if (data == "") {
            USER_API.getEquipment("Logement").then(({ data }) => {
              this.loadEquipment(data);
              if (data == "") {
                USER_API.getEquipment("Alim").then(({ data }) => {
                  this.loadEquipment(data);
                  if (data == "") {
                    alert(
                      "Attention il n'y a ni location ni logement ni élément"
                    );
                  }
                });
              }
            });
          }
        });
      }
    },
    loadDocumentsImages() {
      this.getDocuments.forEach(doc => {
        USER_API.getDocument(doc.id, true).then(async response => {
          if (!this.getDocumentsImages.find(el => el.id === doc.id)) {
            const img = await blobToImage(response.data);
            this.addDocumentsImages({
              id: doc.id,
              name: doc.name,
              image: img.src,
              entities_id: doc.entities_id
            });
          }
        });
      });
    },
    async loadEquipmentsData(ticketsData) {
      const tickets = ticketsData.map(ticket => {
        /*if (false && ticket.name.startsWith("{") && ticket.name.endsWith("}")) {
          try {
            const name = JSON.parse(ticket.name);
            await this.loadItemType(name.itemtype);
            ticket.name = name.titre;
            ticket.itemtype = name.itemtype;
            ticket.itemtypeID = name.itemtypeID;
            ticket.equipment = this.getTypeName(name.itemtype, name.itemtypeID);
          } catch (error) {
            console.log(error);
          }
        } else {*/
        ticket.equipment =
          ticket.locations_id === 0
            ? this.$t("no_equipment")
            : ticket.locations_id;
        ticket.no_equipment = ticket.locations_id === 0;
        //}
        return ticket;
      });
      this.loadAllTickets(tickets);
      return tickets;
    },
    loadCalendar() {
      TICKET_API.getReservationItems().then(({ data }) => {
        let reservationItems = data;
        TICKET_API.getReservations().then(({ data }) => {
          reservationItems.forEach(async item => {
            let reservations = data
              .filter(
                el => el.reservationitems_id === item.id && shouldDisplay(el)
              )
              .map(el => {
                el.entities_id = item.entities_id;
                return el;
              });
            reservations = uniqueElementBy(
              reservations,
              (a, b) => a.id === b.id
            );
            this.loadReservations(reservations);
          });
        });
      });
    },
    changeLang() {
      this.$nextTick(() => {
        const local = this.languages[this.language].local;
        this.$store.dispatch("changeLang", local);
        this.$root.$i18n.locale = local;
      });
    },
    support() {
      let itID = 0;
      let urlSupport = "";
      let comment = this.getUserData.comment;
      try {
        USER_API.commentUser(this.getUserId, comment + " - click support");
      } catch ({ response }) {
        this.errors.push({
          title: "attention",
          msg: response.data,
          snackbar: true
        });
      }
      setTimeout(() => {
        this.errors = [];
        this.$router.go(0);
      }, 500);
      try {
        let conf = JSON.parse(
          this.getEntity.filter(el => el.level === 4)[0].website
        );
        itID = conf.ids.support;
      } catch {
        return false;
      }
      if (
        //CIMALPES
        this.getEntity.filter(el => el.level === 4)[0].id == 345 ||
        this.getEntity.filter(el => el.level === 4)[0].id == 359
      ) {
        urlSupport =
          PORTAL_CONFIG.URL_SUPPORT +
          "/support/313/u/mLMzljkCHfDpwjc1xeURFb2gkwJ96MX0AP7TNGWX" +
          "/it/location/itid/" +
          itID;
      } else {
        urlSupport =
          PORTAL_CONFIG.URL_SUPPORT +
          "/support/" +
          PORTAL_CONFIG.ENTITY_SUPPORT +
          "/u/" +
          PORTAL_CONFIG.TOKEN_SUPPORT +
          "/it/location/itid/" +
          itID;
      }
      let alignement = this.$vuetify.breakpoint.width - 1200;
      const windowFeatures = "left=" + alignement + ",width=1200,height=800";
      window.open(urlSupport, "_blank", windowFeatures);
    },
    tuto() {
      let urlSupport = "";
      let comment = this.getUserData.comment;
      try {
        USER_API.commentUser(this.getUserId, comment + " - click tuto");
      } catch ({ response }) {
        this.errors.push({
          title: "attention",
          msg: response.data,
          snackbar: true
        });
      }
      setTimeout(() => {
        this.errors = [];
        this.$router.go(0);
      }, 500);
      if (
        //en attendant que CIMALPES ait son serveur
        this.getEntity.filter(el => el.level === 4)[0].id == 345 ||
        this.getEntity.filter(el => el.level === 4)[0].id == 359
      ) {
        urlSupport =
          PORTAL_CONFIG.URL_SUPPORT +
          "/tuto/313" +
          "/u/mLMzljkCHfDpwjc1xeURFb2gkwJ96MX0AP7TNGWX";
      } else {
        urlSupport =
          PORTAL_CONFIG.URL_SUPPORT +
          "/tuto/" +
          PORTAL_CONFIG.ENTITY_SUPPORT +
          "/u/" +
          PORTAL_CONFIG.TOKEN_SUPPORT;
      }
      let alignement = this.$vuetify.breakpoint.width - 1200;
      const windowFeatures = "left=" + alignement + ",width=1200,height=800";
      window.open(urlSupport, "_blank", windowFeatures);
    }
  },
  mixins: [LayoutOptions, TreeViewData, TicketsData, AssetsData],
  watch: {
    /*loaded() {
      if (this.loaded && !this.$route.meta.directLink) {
        this.$router.push("/assets/index");
      }
    },*/
    getDocumentsLoadStatus() {
      if (this.getDocumentsLoadStatus === loadStates.SUCCESS) {
        this.loadDocumentsImages();
      }
    },
    getEquipmentLoadStatus() {
      if (this.getEquipmentLoadStatus === loadStates.SUCCESS) {
        this.loadTicketsData();
      }
    },
    pageTitle() {
      document.title = this.pageTitle;
    },
    entitiesLoaded() {
      this.loadData();
    },
    isSessionLoading() {
      if (!this.isSessionLoading) {
        this.loadEquipData();
      }
    },
    getActiveEntity() {
      this.loadUsers();
    }
  }
};
</script>
<style>
.leaflet-tooltip,
.leaflet-tooltip-pane {
  z-index: 400 !important;
}
.leaflet-pane {
  z-index: inherit !important;
}
.leaflet-top,
.leaflet-bottom {
  z-index: 1 !important;
}
</style>
